import { PARTNERS } from "@/data/content";

export default function Partners() {
  const row = [...PARTNERS, ...PARTNERS];
  return (
    <section id="partners" data-testid="partners-section" className="py-16 md:py-20 bg-white border-y border-black/5">
      <div className="container-x text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#0A3161]/15 bg-[#0A3161]/5 px-3 py-1 text-[12px] font-semibold text-[#0A3161]">
          Placement Partners
        </div>
        <h2 className="mt-4 font-display text-3xl md:text-4xl font-bold text-slate-900">
          Our alumni work at <span className="text-[#B31942]">500+</span> product & service companies.
        </h2>
      </div>

      <div className="mt-10 relative marquee-mask">
        <div className="flex gap-4 md:gap-6 animate-marquee w-max">
          {row.map((p, i) => (
            <div
              key={i}
              data-testid={`partner-${i}`}
              className="shrink-0 rounded-2xl border border-black/5 bg-[#F8F9FA] px-6 md:px-8 py-4 md:py-5 min-w-[180px] md:min-w-[220px] text-center"
            >
              <div className="font-display text-lg md:text-xl font-bold text-slate-800">{p}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
